import { Alert, Autocomplete, Box, Button, CircularProgress, FormControl, FormControlLabel, Grid2, IconButton, InputLabel, MenuItem, Paper, Select, Stack, Switch, TextField, Tooltip, Typography, styled } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import classes from "./Workbench.module.css";
import React, { Fragment, useEffect, useMemo, useState, useContext, useCallback, useRef } from 'react';
import swal from 'sweetalert';
import Sidebar from '../Layout/Sidebar';
import Header from '../Layout/Header';
import { Cancel, CancelPresentation, Close, Download, FileDownload } from '@mui/icons-material';
import { Link, NavLink, useLocation, useParams } from 'react-router-dom';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import { useSnackbar } from "notistack";
import { ToggleContext, UserContext } from "../../hooks/UserContext";
import AssignBulkPopup from "../CaseAssignment/AssignBulkPopup";
import ReportScreenPopup from "../ReportScreens/ReportScreenPopup";
import { getEmail, getMSID, getName, getToken } from '../../authfile';
import useLoader from '../../hooks/useLoader';
import { useUpdateWorkbenchData } from '../../queries/useUpdateWorkbenchData';
import Loader from "../UI/Loader";
import { UNASSIGNED, COMPLETED, ASSIGNED, INPROGRESS } from '../../constants/miscConstants';
import { DUAL_ACCOUNT_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT } from '../../constants/reportNames';
import {  CANCEL, OK } from '../../constants/miscConstants';
import { useGetCaseHistoryData } from '../../queries/useGetCaseHistoryData';
import { Leftpart } from '../UI/Template/Leftpart';
import { RightPart } from '../UI/Template/Rightpart';
import { ContentLayout } from '../UI/Template/ContentLayout';
import Modal from '@mui/material/Modal';
import { useGetSurveyQuestionnaire } from '../../queries/useGetSurveyQuestionnaire';
import { useWorkbenchData } from '../../hooks/useWorkbenchData';
import WithConditional from '../hoc/WithConditional';
import { ADMIN,TECHNICIAN } from '../../constants/routeConstants';
import { DateFormatTo_MM_DD_YYYY } from '../../utils/DateFormatter';
import CustomizedSnackbars from '../UI/SnackBar';
import AppInsight from '../Azure/AppInsights';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  border: '0.2rem solid #002277',
  boxShadow: 24,
  px: 3,
  overflow: 'auto',
};

const styleOfBulkassignment = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '90%',
  bgcolor: 'background.paper',
  border: '0.2rem solid #002277',
  boxShadow: 24,
  px: 3,
  overflow: 'auto',
};

const Workbench = () => {
  const tokenConfig = {
    headers: {
        "Authorization": `Bearer ${getToken()}`,
    },
  };
  const [selectionType, setSelectionType] = useState("days");
  const [startDate, setStartDate] = useState(dayjs().subtract(15, 'day'));
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  const [ranges, setRanges] = useState(15);
  const [validationErrors, setValidationErrors] = useState({});
  const [assignedCases, setAssignedCases] = useState({});
  const [showAssignBulkPopup, setShowAssignBulkPopup] = useState(false);
  const [popupChange, setPopupChange] = useState(false);
  const [showReportPopup, setShowReportPopup] = useState(false);
  const [reportDetails, setReportDetails] = useState({});
  const [bulkAssignCaseData, setBulkAssignCaseData] = useState('')
  const [workStatusList, setWorkStatusList] = useState([ASSIGNED, UNASSIGNED, INPROGRESS, COMPLETED]);
  const [restrictedOptions, setRestrictedOptions] = useState(["True", "False"]);
  const [loader, showLoader, hideLoader] = useLoader();
  const { userRole } = useContext(UserContext);
  const auditorsStore = useRef({});
  const [toggleForTech, setToggleForTech] = useState(false);
  const msid = getMSID();
  const [sorting,setSorting] = useState([
    {
      id: 'SLA_COMPLIANCE', //sort by age by default on page load
      desc: false,
    },
    {
      id: 'PRIORITY',
      desc: true
    }
  ]);
  const { report } = useLocation().state || {
    report: DUAL_ACCOUNT_REPORT
  }
  const { enqueueSnackbar } = useSnackbar();
  const details = {
    name: getName(),
    email: getEmail(),
    msid: getMSID(),
    role: toggleForTech == true ? TECHNICIAN : userRole,
    report: report
  }
  // console.log("report in the main heading", report);
  const differenceInDays = endDate.diff(startDate, 'day');
  const formattedDateStart = startDate ? DateFormatTo_MM_DD_YYYY(startDate) : '';
  const formattedDateEnd = endDate ? DateFormatTo_MM_DD_YYYY(endDate) : '';

  let defaultSortingLogicOfColumns = [
    {
      id: 'SLA_COMPLIANCE', //sort by age by default on page load
      desc: false,
    },
    {
      id: 'PRIORITY',
      desc: true
    }
  ];

  const { mutateAsync: updateUsers, isLoading: isUpdatingUsers } =
    useUpdateWorkbenchData({report});

  const {
    data,
    isError: isWorkbenchDataError,
    error: workbenchDataError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
    refetch: refetchData
  } = useWorkbenchData({body: {
    ...details,
    fromDate: formattedDateStart,
    toDate: formattedDateEnd
  }, config: tokenConfig});

  const { mutateAsync: getCaseHistory } = useGetCaseHistoryData();

  const { mutateAsync: getSurveyQuestionnaire, isLoading: isLoadingDownloadingAllSurveyAnswers } = useGetSurveyQuestionnaire();

  //console.log("workbench Data is",data);

  let columns = useMemo(
    () => [
      {
        accessorKey: 'CASE_ID', //normal accessorKey
        header: 'PA NUMBER',
        Header: ({ column }) => (
          <Tooltip title="PA Number" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        // enableClickToCopy: true,
        size: 30,
        enableColumnFilter: true,
        muiTableHeadCellProps: {
          sx: {
            marginLeft: "0.2rem"
          }
        },
        filterFn: (row, columnId, filterValue) => {
          // console.log("date is...",date);
          if (row.original.CASE_ID.toLowerCase().includes(filterValue.toLowerCase()))
            return true;
          else
            return false;
        },
        Cell: ({ row }) => {
          let caseId = row.original.CASE_ID;
          return <div>
            <Button sx={{
              userSelect: 'text'
            }} onClick={() => {
              if (row.original.WORK_STATUS == UNASSIGNED) {
                enqueueSnackbar("Please assign the case and Save", {
                  variant: "warning"
                });
                return;
              }
              handleShowReportPopup({
                caseId: caseId,
                status: row.original.WORK_STATUS
              })
            }}>{caseId}</Button>
          </div>
        },
        enableEditing: false,
      },
      {
        
        accessorKey:'SLA_COMPLIANCE',
        header: 'SLA COMPLIANCE DATE',
        Header: ({ column }) => (
          <Tooltip title="SLA Compliance Date" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        size: 30,
        enableEditing: false,
        filterVariant: 'date',
        sortingFn: (rowA, rowB, columnId) => {
          // console.log("rowA", rowA);
          // console.log("rowB", rowB);
          if (rowA.original.SLA_COMPLIANCE == null || rowA.original.SLA_COMPLIANCE == undefined) {
            return -1;
          }
          if (rowB.original.SLA_COMPLIANCE == null || rowB.original.SLA_COMPLIANCE == undefined) {
            return 1;
          }
          const firstDate = new Date(rowA.original.SLA_COMPLIANCE);
          const secondDate = new Date(rowB.original.SLA_COMPLIANCE);
          return firstDate > secondDate ? 1 : -1;
        },
        filterFn: (row, columnId, filterValue) => {
          if(row.original.SLA_COMPLIANCE === null || row.original.SLA_COMPLIANCE === undefined){
            return false;
          }
          const rowValue = new Date(new Date(row.original.SLA_COMPLIANCE));
          rowValue.setHours(0, 0, 0, 0);
          const start = filterValue;
          const startDate = start ? new Date(start) : null;


          if (!start)
            return true;


          if (startDate)
            startDate.setHours(0, 0, 0, 0);


          //console.log("startDate is",startDate,"rowValue",rowValue);

          if (startDate)
            return rowValue.toDateString() === startDate.toDateString();

        },

        enableColumnFilter: true,

      },
      {
        accessorKey: 'TECHNICIAN_ASSIGNED',
        header: 'AUDITOR/ MSID',
        Header: ({ column }) => (
          <Tooltip title="Auditor / MSID" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        size: 250,
        maxSize: 250,
        enableColumnFilter: true,
        sortingFn: (rowA, rowB, columnId) => {
          // console.log("rowA", rowA);
          // console.log("rowB", rowB);
          if (rowA.original.TECHNICIAN_ASSIGNED == null || rowA.original.TECHNICIAN_ASSIGNED == undefined) {
            return -1;
          }
          if (rowB.original.TECHNICIAN_ASSIGNED == null || rowB.original.TECHNICIAN_ASSIGNED == undefined) {
            return 1;
          }
          return rowA.original.TECHNICIAN_ASSIGNED.localeCompare(rowB.original.TECHNICIAN_ASSIGNED)
        },
        filterFn: (row, columnId, filterValue) => {
          if (row.original?.TECHNICIAN_ASSIGNED?.toLowerCase()?.includes(filterValue?.toLowerCase()))
            return true;

          else
            return false;
        },
        muiEditTextFieldProps: ({ row }) => ({
          select: true,
          error: !!validationErrors?.user,
          helperText: validationErrors?.user,
        }),
        Edit: ({ row, cell }) => {
          return (
            <>
              <Autocomplete
                id="disable-clearable"
                disableClearable
                value={row.original.TECHNICIAN_ASSIGNED}
                sx={{
                  display: 'inline-block',
                  width: '85%',
                  '& input': {
                    width: '120px !important',
                    fontSize: '13px !important'
                  },
                }}
                onChange={(event, newValue) => {
                  row.original.TECHNICIAN_ASSIGNED = newValue;
                  setAssignedCases((prev) => ({
                    ...prev,
                    [row.id]: {
                      id: row.id,
                      caseId: row.original.CASE_ID,
                      technician: newValue?.split("/")[1],
                    }
                  }))


                  // row.original.TECHNICIAN_ASSIGNED = newValue;
                  // setAssignedCases((prev) => ({
                  //   ...prev,
                  //   [row.id]: {
                  //     id: row.id,
                  //     caseId: row.original.CASE_ID,
                  //     technician: newValue?.split("/")[1],
                  //   }
                  // }))

                }
                }
                options={data?.userList}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      padding: '0px !important',
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                  />
                )}
              />
            </>
          )
        }
      },
      {
        accessorKey: 'CARRIER_CODE', //normal accessorKey
        header: 'CARRIER CODE',
        Header: ({ column }) => (
          <Tooltip title="Carrier Code" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        size: 50,
        enableEditing: false,
        filterFn: (row, columnId, filterValue) => {


          // console.log("date is...",date);
          if (row.original.CARRIER_CODE.toLowerCase().includes(filterValue.toLowerCase()))
            return true;

          else
            return false;
        },
      },
      {
        accessorKey: 'BUSINESS_SEGMENT',
        header: 'BUSINESS SEGMENT',
        Header: ({ column }) => (
          <Tooltip title="Business Segment" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        enableStickyHeader: false,
        muiEditTextfieldProps: {
          title: 'Carrier Code Tooltip', // Add your tooltip text here
        },
        size: 70,
        enableEditing: false,
        filterFn: (row, columnId, filterValue) => {
          // console.log("date is...",date);
          if (row.original.BUSINESS_SEGMENT.toLowerCase().includes(filterValue.toLowerCase()))
            return true;
          else
            return false;
        },
      },
      {
        accessorKey: 'PRIORITY',
        header: 'PRIORITY',
        Header: ({ column }) => (
          <Tooltip title="Priority" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        size: 40,
        enableEditing: false,
        filterFn: (row, columnId, filterValue) => {
          // console.log("date is...",date);
          if (row.original.PRIORITY.toLowerCase().includes(filterValue.toLowerCase()))
            return true;
          else
            return false;
        },
      },
      {
        accessorKey: 'WORK_STATUS',
        header: 'WORK STATUS',
        filterVariant: 'multi-select',
        filterSelectOptions: workStatusList,
        Header: ({ column }) => (
          <Tooltip title="Work Status" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        size: 40,
        enableEditing: false,
      },
      {
        accessorKey: 'isRestricted',
        header: 'IS RESTRICTED',

        Header: ({ column }) => (
          <Tooltip title="Is Restricted" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        size: 40,
        enableEditing: false,
        Cell: ({ cell }) => {
          let val2 = cell.getValue();
          // console.log("value returned from api is",val2);
          //console.log("and it's string format is,",val2?formateDateString(val2):val2);
          return val2 == "1" ? "True" : "False";
        },
        filterVariant: 'select',
        filterSelectOptions: restrictedOptions,
        filterFn: (row, columnId, filterValue) => {
          // console.log("date is...",date);
          let transformedValue = row.original.isRestricted == "1" ? "True" : "false";
          if (transformedValue.toLowerCase().includes(filterValue.toLowerCase()))
            return true;
          else
            return false;
        },
      },
      {
        accessorKey: 'LOAD_DATE',
        header: 'LOAD DATE',
        Header: ({ column }) => (
          <Tooltip title="Load Date" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        maxSize: 180,
        enableEditing: false,
        filterVariant: 'date',
        sortingFn: (rowA, rowB, columnId) => {
          // console.log("rowA", rowA);
          // console.log("rowB", rowB);
          if (rowA.original.LOAD_DATE == null || rowA.original.LOAD_DATE == undefined) {
            return -1;
          }
          if (rowB.original.LOAD_DATE == null || rowB.original.LOAD_DATE == undefined) {
            return 1;
          }
          const firstDate = new Date(rowA.original.LOAD_DATE);
          const secondDate = new Date(rowB.original.LOAD_DATE);
          return firstDate > secondDate ? 1 : -1;
        },
        filterFn: (row, columnId, filterValue) => {
          if(row.original.LOAD_DATE === null || row.original.LOAD_DATE === undefined){
            return false;
          }
          const rowValue = new Date(new Date(row.original.LOAD_DATE));
          rowValue.setHours(0, 0, 0, 0);
          const start = filterValue;
          const startDate = start ? new Date(start) : null;
          if (!start)
            return true;
          if (startDate)
            startDate.setHours(0, 0, 0, 0);
          if (startDate)
            return rowValue.toDateString() === startDate.toDateString();
        },
        // filterFn: (row,columnId,filterValue)=>{
        //   const date = formateDateString(row.original.LOAD_DATE);
        //  // console.log("date is...",date);
        //   if(date.includes(filterValue))
        //   return true;
        //   else 
        //   return false;
        // },
        enableColumnFilter: true,
         
      },
      {
        accessorKey: 'TECHNICIAN_ASSIGNED_DATE_TIME',
        header: 'ASSIGNED DATE',
        Header: ({ column }) => (
          <Tooltip title="Assigned Date" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        maxSize: 220,
        enableEditing: false,


        filterVariant: 'date',
        sortingFn: (rowA, rowB, columnId) => {
          // console.log("rowA", rowA);
          // console.log("rowB", rowB);
          if (rowA.original.TECHNICIAN_ASSIGNED_DATE_TIME == null || rowA.original.TECHNICIAN_ASSIGNED_DATE_TIME == undefined) {
            return -1;
          }
          if (rowB.original.TECHNICIAN_ASSIGNED_DATE_TIME == null || rowB.original.TECHNICIAN_ASSIGNED_DATE_TIME == undefined) {
            return 1;
          }
          const firstDate = new Date(rowA.original.TECHNICIAN_ASSIGNED_DATE_TIME);
          const secondDate = new Date(rowB.original.TECHNICIAN_ASSIGNED_DATE_TIME);
          return firstDate > secondDate ? 1 : -1;
        },
        filterFn: (row, columnId, filterValue) => {
          //console.log("row is", row);
          if(row.original.TECHNICIAN_ASSIGNED_DATE_TIME === null || row.original.TECHNICIAN_ASSIGNED_DATE_TIME === undefined){
            return false;
          }
          const rowValue = new Date(new Date(row.original.TECHNICIAN_ASSIGNED_DATE_TIME));
          rowValue.setHours(0, 0, 0, 0);
          const start = filterValue;
          const startDate = start ? new Date(start) : null;
          if (!start)
            return true;
          if (startDate)
            startDate.setHours(0, 0, 0, 0);
          if (startDate)
            return rowValue.toDateString() === startDate.toDateString();
        },

        enableColumnFilter: true,

      },
      {
        accessorKey: 'LAST_UPDATED_DATETIME',
        header: 'LAST UPDATED DATE',
        Header: ({ column }) => (
          <Tooltip title="Last Updated Date" placement="top">
            <span>{column.columnDef.header}</span>
          </Tooltip>
        ), //arrow function
        size: 40,
        enableEditing: false,

        filterVariant: 'date',
        sortingFn: (rowA, rowB, columnId) => {
          // console.log("rowA", rowA);
          // console.log("rowB", rowB);
          if (rowA.original.LAST_UPDATED_DATETIME == null || rowA.original.LAST_UPDATED_DATETIME == undefined) {
            return -1;
          }
          if (rowB.original.LAST_UPDATED_DATETIME == null || rowB.original.LAST_UPDATED_DATETIME == undefined) {
            return 1;
          }
          const firstDate = new Date(rowA.original.LAST_UPDATED_DATETIME);
          const secondDate = new Date(rowB.original.LAST_UPDATED_DATETIME);
          return firstDate > secondDate ? 1 : -1;
        },
        filterFn: (row, columnId, filterValue) => {
          if(row.original.LAST_UPDATED_DATETIME === null || row.original.LAST_UPDATED_DATETIME === undefined){
            return false;
          }
          const rowValue = new Date(new Date(row.original.LAST_UPDATED_DATETIME));
          rowValue.setHours(0, 0, 0, 0);
          const start = filterValue;
          const startDate = start ? new Date(start) : null;
          if (!start)
            return true;
          if (startDate)
            startDate.setHours(0, 0, 0, 0);
          if (startDate)
            return rowValue.toDateString() === startDate.toDateString();
        },
        enableColumnFilter: true,
      },
      {
        accessorKey: 'Download',
        header: 'DOWNLOAD HISTORY',
        filterVariant: 'select',
        filterSelectOptions: workStatusList,
        muiTableBodyCellProps: {
          align: "center"
        },
        Cell: ({ cell, row }) =>

          (row.original.WORK_STATUS === INPROGRESS || row.original.WORK_STATUS === COMPLETED) && <IconButton onClick={() => {
            handleDownloadCaseHistory(row.original.CASE_ID)
          }}>
            <Download sx={{ cursor: 'pointer' }} color='primary' />
          </IconButton> 


        ,
        size: 40,
        enableEditing: false,
      },
    ],
    [data?.userList, assignedCases, report],
  );

  // columns restructuring
  // For some reports only some columns has to be displayed, and for some reports only some columns has to be displayed
  // we are following some conditions to display that
  const TECHNICIAN_ASSIGNED = 'TECHNICIAN_ASSIGNED';
  const SLA_COMPLIANCE = 'SLA_COMPLIANCE';
  const BUSINESS_SEGMENT = 'BUSINESS_SEGMENT';

  if (userRole === TECHNICIAN || toggleForTech) {
    columns = columns.filter(col => col.accessorKey !== TECHNICIAN_ASSIGNED);
  }

  const reportsWithOutSLAAndBusinessSegment = [XCPINDEXING_REPORT, INBOUND_CORR_WB_REPORT, DUAL_ACCOUNT_REPORT];
  const reportsWithOutSLAOnly = [UHCEI_DUPLICATE_DENIAL_REPORT];

  if (reportsWithOutSLAAndBusinessSegment.includes(report)) {
    columns = columns.filter(col => col.accessorKey !== SLA_COMPLIANCE && col.accessorKey !== BUSINESS_SEGMENT);
  } else if (reportsWithOutSLAOnly.includes(report)) {
    columns = columns.filter(col => col.accessorKey !== SLA_COMPLIANCE);
  }

  // // sorting logic
  // if(report == DUAL_ACCOUNT_REPORT || report == PART_D_DUPLICATE_REPORT){
  //   defaultSortingLogicOfColumns = [
  //     {
  //       id: 'PRIORITY',
  //       desc: true
  //     }
  //   ]
  // }

  // console.log("columns is ", columns);

  

  const table = useMaterialReactTable({
    columns,
    data: data?.gridData || [],
    //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    enableGlobalFilter: false,
    groupedColumnMode: 'remove',
    layoutMode: 'semantic',
    enableEditing: true,
    editDisplayMode: 'table',
    onSortingChange: setSorting,
    state: {sorting},
    initialState: {
      density: 'compact',
      columnVisibility: { adjusted_claim_id: false, rts_report: false, violation: false, claim_reference_number: false },
      columnOrder: [
        'CASE_ID',
        'SLA_COMPLIANCE',
        'TECHNICIAN_ASSIGNED',
        'CARRIER_CODE',
        'BUSINESS_SEGMENT',
        'PRIORITY',
        'WORK_STATUS',
        'isRestricted',
        'LOAD_DATE',
        'TECHNICIAN_ASSIGNED_DATE_TIME',
        'LAST_UPDATED_DATETIME',
      ],
    },
    enableDensityToggle: false,
    enableSelectAll: false,
    enableStickyHeader: false,
    // layoutMode: 'grid',
    // getRowId: (row) => row.userId, //give each row a more useful id
    // onRowSelectionChange: setRowSelection, //connect internal row selection state to your own
    // state: { rowSelection },
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      align: 'left',
      sx: {
        fontSize: '0.8rem',
        padding: '0px'
      },
    }),
    muiTableHeadCellProps: {
      align: 'left',
      sx: {
        fontSize: '15px',
        padding: '0.5rem 0.6rem 0.5rem 0.1rem',

      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}
      >
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={handleExportData}
          startIcon={<FileDownload />}
        >
          Export All Data
        </Button>
        <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)
          onClick={() =>
            handleExportRows(table.getPrePaginationRowModel().rows)
          }
          startIcon={<FileDownload />}
        >
          Export Filtered Data
        </Button>
        {(userRole == ADMIN && toggleForTech == false) ?
          <Button
            variant="contained"
            disabled={table.getPrePaginationRowModel().rows.filter(item => item.original.WORK_STATUS === "Unassigned").length === 0}
            //export all rows, including from the next page, (still respects filtering and sorting)
            onClick={() =>
              handleViewHistoryPopup()
            }
            sx={{
              backgroundColor: '#002677',
              color: 'white',
            }}
          >
            Assign Cases
          </Button> : ""}


        {/* <Button
                 disabled={table.getSelectedRowModel().rows.length === 0||!selectionEnable}
                //export all rows, including from the next page, (still respects filtering and sorting)
                  onClick={() => {
                    //const rowSelection = table.getState().rowSelection; //read state
                    const selectedRows = table.getSelectedRowModel().rows; //or read entire rows
                    handleDownloadClaims(selectedRows);
                  }}
                // }
                 startIcon={<FileDownload />}
              >
                Export Filtered Claim Documents
              </Button> */}
      </Box>
    ),
    renderBottomToolbarCustomActions: () => (
      <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
        {userRole == ADMIN && (<Button
          color="success"
          variant="contained"
          onClick={() => {
            const result = updateUsers({body: {
              data: Object.values(assignedCases),
              updatedBy: getMSID(),
              report: report
            }, config: tokenConfig});
            result.then((res) => {
              if(res.data.error){
                throw new Error(res.data.message);
              }
              
                enqueueSnackbar("Case assignment is successful",{
                  variant: 'success'
                });
                setAssignedCases({});
              
            }).catch((err) => {
              enqueueSnackbar(`something went wrong, ${err.message}`,{
            variant: 'error'
            });
            AppInsight.trackEvent({ name: `RQA => Updating single assignment Workbench Data, msid=> ${msid}`, properties: { errorMessage: "Something went wrong in single assignment of workbench data" } });
        
          
          });
          }}
          disabled={
            Object.keys(assignedCases).length === 0 ||
            Object.values(validationErrors).some((error) => !!error)
          }
        >
          {isUpdatingUsers ? <CircularProgress size={25} /> : 'Save'}
        </Button>)}
        {Object.values(validationErrors).some((error) => !!error) && (
          <Typography color="error">Fix errors before submitting</Typography>
        )}

        {/* {userRole == 1 && (
              <Button
                calledFrom='delete'
                color="error"
                variant="contained"
                disabled={table.getSelectedRowModel().rows.length === 0 || !selectionEnable}
                onClick={() => {
                  // setButtonClicked('buttonDelete');
                  // const selectedRows = table.getSelectedRowModel().rows;
                  handleSubmit();
                }}
              >
                Delete
              </Button>
            )} */}
      </Box>
    )

  });

  // console.log("table is", table.getState().columnFilters)

  const downloadFileWithCSVLib = (fileName,data) => {
    const csvConfigFilteredData = mkConfig({
        filename: fileName,
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: true,
      });
      const csv = generateCsv(csvConfigFilteredData)(data);
      download(csvConfigFilteredData)(csv);
}

  const closePopup = () => {
    setShowAssignBulkPopup(false);
  }

  const handleViewHistoryPopup = () => {
    setShowAssignBulkPopup(true);
    setPopupChange(!popupChange);
  }

  const handleShowReportPopup = (obj) => {
    setReportDetails(obj);
    setShowReportPopup(true);
  }

  const handleCloseReportPopup = () => {
    setShowReportPopup(false);
  }



  const calculateDays = (days) => {
    const start = new Date();
    start.setDate(start.getDate() - days);
    // console.log('start is', start);
    return start;
  }

  const handleSelectionChange = (e) => {
    setSelectionType(e.target.value);
    if(e.target.value === "days"){
      handleChange({target:{value: 90}})
    }
  };


  const handleChange = (event) => {
    const selectedRange = parseInt(event.target.value, 10);
    setRanges(selectedRange);
    //console.log("start Date in handleChange", calculateDays(selectedRange));
    setStartDate(calculateDays(selectedRange));
    setEndDate(dayjs(new Date()));
  }

  const handleExportData = () => {
    if (data == null || data == undefined || data?.gridData.length == 0) {
      enqueueSnackbar('No Data To Export', {
        variant: "warning",
      })
      return;
    }
    const fileName = `${report}_data`;
    const rawData = data?.gridData;
    downloadFileWithCSVLib(fileName,rawData);
  }

  const handleExportRows = (rows) => {
    const fileName = `${report}_filtered_data`;
    const rawData = rows.map((row) => row.original);
    downloadFileWithCSVLib(fileName,rawData);
  }


  const handleDownloadCaseHistory = (case_id) => {
    const result = getCaseHistory({body: { report: report, case_id: case_id }, config: tokenConfig});
    result.then((res) => {
      if (res.data.length === 0) {
        enqueueSnackbar("There is no history to download", {
          variant: "warning"
        });
      if(res.data.error){
        throw new Error();
      }
        return;
      }
      const fileName = `${report}_${case_id}_case_history`;
      const rawData = res.data;
      downloadFileWithCSVLib(fileName,rawData);
    }).catch(err => {
      enqueueSnackbar("Something went wrong in downloading case history", {
        variant: 'error'
      });
      AppInsight.trackEvent({ name: `RQA => Downloading Case History API Error, msid=> ${msid}`, properties: { errorMessage: "Something went wrong in downloading case history" } });
    })

  }
 

  const handleDownloadSurveyQuestionnaire = () => {
    const result = getSurveyQuestionnaire({body: { report: report, fromDate: formattedDateStart, toDate: formattedDateEnd, role: toggleForTech ? TECHNICIAN : userRole, msid: getMSID() },config:tokenConfig});
    result.then((res) => {
      if (res.data.length === 0) {
        enqueueSnackbar("There is no data to download", {
          variant: "warning"
        });
      if(res.data.error){
        throw new Error();
      }
        return;
      }
      const fileName = `${report}_survey_questionnaire`;
      const rawData = res.data;
      downloadFileWithCSVLib(fileName,rawData);
    }).catch(err => {
      enqueueSnackbar("Something went wrong in downloading survey answers for all completed cases", {
        variant: 'error'
      });
      AppInsight.trackEvent({ name: `RQA => Completed Cases Survey Answers API Error, msid=> ${msid}`, properties: { errorMessage: "Something went wrong in downloading survey answers for all completed cases" } });
    })
  }


  useEffect(() => {
    table.resetColumnFilters();
    if(report == DUAL_ACCOUNT_REPORT || report == PART_D_DUPLICATE_REPORT){
      setSorting([{id: 'PRIORITY',desc: true}])
    }else if(report == PART_D_IE_REPORT || report == PART_D_MULTIPLE_REPORT){
      setSorting([{
        id: 'SLA_COMPLIANCE', //sort by age by default on page load
        desc: false,
      }])
    }
    else{
      setSorting(defaultSortingLogicOfColumns);
    }
  }, [report])

  

  // useEffect(() => {
  //   data?.gridData.map((eachCase) => {
  //     auditorsStore.current[eachCase.CASE_ID] = eachCase.TECHNICIAN_ASSIGNED
  //   })
  // }, [data])

  // console.log("isFiltered:", table.getState().columnFilters.length);

  return (
    <>
      <ContentLayout>
      <WithConditional when={isWorkbenchDataError}>
      <CustomizedSnackbars type="error" API="Workbench Data API" message={workbenchDataError?.message} />
    </WithConditional>
    <WithConditional when={isFetchingUsers || isUpdatingUsers || isLoadingDownloadingAllSurveyAnswers}>
      <Loader message="Loading"/>
    </WithConditional>
  
            
        <Modal
          open={showAssignBulkPopup}
          onClose={closePopup}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleOfBulkassignment}>
            <AssignBulkPopup userList={data?.userList} reportName={report} cases={table.getSortedRowModel().rows.filter(item => item.original.WORK_STATUS === "Unassigned")} isFiltered={table.getState().columnFilters.length > 0} closePopup={closePopup} />
          </Box>
        </Modal>
        <Modal
          open={showReportPopup}
          onClose={handleCloseReportPopup}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Stack sx={{ position: 'sticky', top: '-1px', backgroundColor: 'white', my: 0.5, py: 0.5, alignItems: 'center' }}>
              <Typography variant="h6" color='#002277' sx={{ width: 'fit-content', padding: '0rem auto 2rem' }}>{report.toUpperCase()} QUESTIONNAIRE</Typography>
              <Close onClick={handleCloseReportPopup} style={{ position: 'absolute', right: '0', cursor: 'pointer' }} />
              <div style={{
                height: '0.5vh',
                width: '100%',
                borderRadius: '1rem',
                backgroundColor: '#afafb2'
              }}></div>
            </Stack>
            <ReportScreenPopup caseId={reportDetails.caseId} role={userRole} status={reportDetails.status} reportName={report} closePopup={handleCloseReportPopup} />
          </Box>
        </Modal>
          <Leftpart>
          <Sidebar technicianCountData={data?.TechnicianCountData} isLoading={isFetchingUsers || isUpdatingUsers} />
        </Leftpart>
        <RightPart>
          {differenceInDays > 90 && <Alert severity="warning" sx={{ mx: 1 }}>No of days between dates must be less than 90</Alert>}
          <div className={classes.rowFilters} >
            {
              userRole == ADMIN &&
              <FormControlLabel sx={{ marginRight: '1rem' }} className={classes.dayFilterLeft} control={<Switch checked={toggleForTech} onChange={() => {
                setToggleForTech((prev) => !prev)
              }} />

              } labelPlacement='start' label="CHANGE TO MYWORKBENCH" />
            }
            <div className={classes.dayFilterRight}>
              <FormControl sx={{ mx: 1 }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectionType}
                  onChange={handleSelectionChange}
                  sx={{ '& .MuiSelect-select': { padding: '0.5rem ' } }}
                >
                  <MenuItem value="days">Days</MenuItem>
                  <MenuItem value="date">Date</MenuItem>
                </Select>
              </FormControl>
              <WithConditional when={selectionType === "days"}>
              <FormControl sx={{ mx: 1 }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={ranges}
                    onChange={handleChange}
                    sx={{ '& .MuiSelect-select': { padding: '0.5rem ' } }}
                  >
                    <MenuItem value={7}>Last 7 Days</MenuItem>
                    <MenuItem value={15}>Last 15 Days</MenuItem>
                    <MenuItem value={30}>Last 30 Days</MenuItem>
                    <MenuItem value={45}>Last 45 Days</MenuItem>
                    <MenuItem value={90}>Last 90 Days</MenuItem>
                  </Select>
                </FormControl>
              </WithConditional>
              <WithConditional when={selectionType === "date"}>
              <div className={classes.startDate}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker label="Start Date"
                        // value={startDate}
                        sx={{
                          display: 'inline-block',
                          '& input': {
                            padding: '8px 14px !important',
                          },

                          '& .MuiInputLabel-root': {
                            marginTop: '-3% !important',
                          }

                        }}
                        onChange={(newValue) => setStartDate(newValue)}
                        format="MM-DD-YYYY"
                      />
                    </LocalizationProvider>
                  </div>
                  <div className={classes.endDate}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker label="End date"
                        // value={endDate}
                        sx={{
                          display: 'inline-block',
                          '& input': {
                            padding: '8px 14px !important',
                          },
                          '& .MuiInputLabel-root': {
                            marginTop: '-3% !important',
                          }

                        }}
                        onChange={(newValue) => setEndDate(newValue)}
                        format="MM-DD-YYYY"
                      />
                    </LocalizationProvider>
                  </div>
              </WithConditional>
              <Button variant='contained' sx={{ mx: 1, backgroundColor: '#002677', padding: '0.5rem' }} onClick={() => refetchData()} className="getResults" >Get Results</Button>
              <Button variant='contained' onClick={() => {
                swal({
                  title: "Are you sure?",
                  text: `You want to download all the completed cases from ${formattedDateStart} to ${formattedDateEnd}`,
                  buttons: {
                    Cancel: {
                      text: 'CANCEL',
                      className: classes.cancel,
                      value: CANCEL
                    },
                    confirm: {
                      text: 'OK',
                      className: classes.confirm,
                      value: OK
                    }
                  }
                  
                })
                .then((value) => {
                  if (value === OK) {
                    handleDownloadSurveyQuestionnaire();
                  }
                });
              }}>Download</Button>
            </div>
          </div>
          <div className={classes.table}>
            <Typography variant="h6" sx={{ my: 1, p: 1, backgroundColor: '#002677', color: '#ffffff', borderRadius: '0.2rem', fontSize: '1.2rem' }}>{report}</Typography>
            {loader}
            <MaterialReactTable table={table} />
          </div>
        </RightPart>
      </ContentLayout>
      {/* <div className={classes.workbenchLeft}> */}
      {/* </div> */}
    </>
  );
};

export default Workbench;